import styled from "@emotion/styled";
import { fontFredoka, theme } from "@product/scmp-sdk";

import { StyledOffsetContainer } from "scmp-app/components/posties/button/styles";

import IconAlertCircle from "./icon-alert-circle.svg";

export const Container = styled.form`
  ${StyledOffsetContainer} {
    margin-block-end: 5px;
  }
`;

export const Wrapper = styled.div`
  ${theme.breakpoints.up("desktop")} {
    inline-size: 307px;
  }
  ${theme.breakpoints.up("mediumDesktop")} {
    inline-size: 442px;
  }
`;

export const DottySpan = styled.span`
  ::after {
    content: "";

    display: inline-block;

    animation: dotty steps(1, end) 2s infinite;
  }

  @keyframes dotty {
    0% {
      content: "";
    }
    25% {
      content: ".";
    }
    50% {
      content: "..";
    }
    75% {
      content: "...";
    }
    100% {
      content: "";
    }
  }
`;

type EmailInputProps = {
  $isError: boolean;
};
export const EmailInput = styled.input<EmailInputProps>`
  inline-size: 100%;
  block-size: 54px;
  padding-inline: 20px;

  font-size: 16px;
  font-family: ${fontFredoka};

  border: 2px solid #000000;
  border-color: ${props => (props.$isError ? "#ff9393" : "#000000")};
  border-radius: 10px;

  background: #ffffff;

  outline: none;
`;

export const TermsAndConditions = styled.div`
  margin-block: 9px;

  color: #ffffff;
  font-size: 12px;
  line-height: 14px;

  ${theme.breakpoints.up("desktop")} {
    font-size: 14px;
    line-height: 17px;
  }
`;

export const GoogleTerms = styled.div`
  margin-block-end: 24px;

  color: #cccccc;
  font-size: 12px;
  font-family: ${fontFredoka};
  line-height: 14px;

  a {
    color: #b2e8ff;
  }

  ${theme.breakpoints.up("desktop")} {
    inline-size: 307px;
    margin-block-end: 44px;
  }

  ${theme.breakpoints.up("largeDesktop")} {
    inline-size: unset;
  }
`;

export const WarningMessage = styled.div`
  display: flex;
  align-content: center;

  margin-block-start: 8px;

  color: #ff9393;
  font-size: 16px;
  font-family: ${fontFredoka};
  line-height: 22px;
`;

export const StyledIconAlertCircle = styled(IconAlertCircle)`
  margin-inline-end: 10px;
`;
